module.exports = __webpack_public_path__ + "static/don33-9c4621e26bbc5427746e36f9e86759cc.jpg";